import { IconButton } from "@mui/material";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { useTranslation } from 'react-i18next';
import ItemDto from "../../models/ItemDto";
import { useCardContent } from "../../provider/CardContentContext";
import { useSnackbarProps } from "../../provider/SnackbarContext";
import { Ref, forwardRef, useImperativeHandle, useState } from "react";
import ItemOptionsDialog, { SelectedItemOptions } from "../dialogs/itemOptionsDialog/ItemOptionsDialog";

type CartAdderProps = {
    item: ItemDto;
    id?: string;
}

export interface CartAdderRef {
    executeClick: () => void;
}

/**
 * If ref is set then the user has to use the "executeClick" function
 * because the component will no longer do this on it's own => would cause the item to be added twice
 */
const CartAdder = forwardRef(({ item }: CartAdderProps, ref: Ref<CartAdderRef>) => {
    const { t } = useTranslation();
    const { addItemToCart } = useCardContent();
    const { showSnackbar } = useSnackbarProps();
    const [opened, setOpened] = useState(false);

    const handleOnclick = (calledFromRef: boolean) => {
        if (ref && !calledFromRef) {
            return;
        }
        if (item.itemOptionGroups.length > 0 || item.itemExtras.length > 0) {
            setOpened(true);
        } else {
            addAnItemToCart();
        }
    }

    const addAnItemToCart = (selectedOptions?: SelectedItemOptions) => {
        showSnackbar({ snackbarText: `${t('snackbarAddedToCart')} ${item.value.value}` });
        addItemToCart(item, selectedOptions);
    }

    useImperativeHandle(ref, () => ({
        executeClick: (): void => {
            handleOnclick(true);
        }
    }));

    const closeDialog = () => {
        // settimeout needed because otherwise it wouldn't update opened state
        setTimeout(() => setOpened(false));
    }

    //TODO IconButton causes Warning: validateDOMNesting(...): <button> cannot appear as a descendant of <button>.
    return (
        <>
            <IconButton sx={{ color: 'white' }} size='small' onClick={() => handleOnclick(false)}>
                <AddShoppingCartIcon sx={{ fontSize: '2rem' }} />
            </IconButton>
            <ItemOptionsDialog
                item={item}
                opened={opened}
                onConfirmation={(selectedOptions: SelectedItemOptions) => addAnItemToCart(selectedOptions)}
                close={() => closeDialog()} />
        </>
    );
});
export default CartAdder;